import { render, staticRenderFns } from "./client-form.vue?vue&type=template&id=85db5942"
import script from "./client-form.vue?vue&type=script&lang=ts"
export * from "./client-form.vue?vue&type=script&lang=ts"
import style0 from "./client-form.vue?vue&type=style&index=0&id=85db5942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports